import { mapGetters } from "vuex";

export const helpers = {
  ...mapGetters([
    'loggedIn',
    'user',
    'settings',
    'settings_sd_switch',
  ])
}
